import React from 'react';
import {withRouter} from 'react-router-dom';
import common from './../../common';
import CreateTeam from './CreateTeam';
import ManageTeam from './../manage-team/manage-team';

const CreateTeamPlayerListingOpen = () => {
    return common.isManageTeam() ? <ManageTeam/> : <CreateTeam/>;
};
export default withRouter(CreateTeamPlayerListingOpen);


// WEBPACK FOOTER //
// ./src/components/onboarding/CreateTeamPlayerListingOpen.js